<eo-base-view [label]="label">
  <p-tag
    *ngIf="value"
    pTooltip="{{ toolTipText }}"
    tooltipPosition="{{ toolTipPosition }}"
    icon="pi pi-{{ icon }}"
    [id]="id"
    [value]="getFormattedValue()"
    [severity]="severity"
    [escape]="false"
  ></p-tag>
  <p *ngIf="!value">-</p>
</eo-base-view>
